import { Link } from "react-router-dom";

const Section = ({ icon, title, children, id }) => (
  <section id={id} className="border-t border-white/10 pt-10 mt-10 first:border-0 first:mt-0 first:pt-0 scroll-mt-24">
    <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00] mb-2">{icon}</div>
    <h2 className="font-display text-4xl md:text-5xl uppercase leading-none">{title}</h2>
    <div className="mt-6 space-y-4 text-white/80 leading-relaxed text-[15px]">{children}</div>
  </section>
);

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-12" data-testid="faq-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00]">FAQ &amp; Politiques officielles</div>
      <h1 className="font-display text-6xl md:text-7xl uppercase leading-none mt-2">Le contrat.</h1>
      <p className="mt-6 text-white/60 text-sm leading-relaxed">
        MerchHub agit uniquement comme <strong className="text-white">plateforme de mise en relation</strong> entre pilotes et acheteurs.
        Nous ne fabriquons pas, n'expédions pas et ne gérons aucun retour. Voici ce que ça implique pour toi.
      </p>

      <div className="mt-8 border border-white/10 p-4 grid grid-cols-2 md:grid-cols-4 gap-2 text-xs uppercase tracking-widest">
        <a href="#remboursement" className="hover:text-[#FF3B00]">Remboursement</a>
        <a href="#livraison" className="hover:text-[#FF3B00]">Livraison</a>
        <a href="#contact" className="hover:text-[#FF3B00]">Contact</a>
        <a href="#acceptation" className="hover:text-[#FF3B00]">Acceptation</a>
      </div>

      <Section id="remboursement" icon="⚖️ Article 1" title="Politique de remboursement et d'échange">
        <p>
          MerchHub agit uniquement comme plateforme de mise en relation entre pilotes et acheteurs.
          Nous ne sommes pas responsables de la fabrication, de l'expédition ou de la gestion des retours.
        </p>
        <p className="text-white/60">En conséquence :</p>
        <ul className="space-y-2 list-disc pl-5 marker:text-[#FF3B00]">
          <li><strong className="text-white">Aucun remboursement, échange ou crédit n'est offert par MerchHub.</strong></li>
          <li>Toute demande liée à un produit (défaut, taille, erreur, échange, etc.) doit être adressée directement au pilote vendeur.</li>
          <li>L'pilote demeure seul responsable de déterminer s'il accepte ou refuse un échange ou une modification de commande.</li>
          <li>En utilisant la plateforme MerchHub, l'acheteur reconnaît que <strong className="text-white">toute transaction est finale du côté de MerchHub</strong>.</li>
        </ul>
      </Section>

      <Section id="livraison" icon="🚚 Article 2" title="Politique de livraison">
        <ul className="space-y-2 list-disc pl-5 marker:text-[#FF3B00]">
          <li>MerchHub ne possède aucun entrepôt et n'effectue aucune expédition.</li>
          <li>Chaque pilote expédie ses propres produits.</li>
          <li>Les délais de livraison peuvent varier d'un pilote à l'autre.</li>
          <li>Les commandes contenant des articles provenant de plusieurs pilotes peuvent être livrées séparément.</li>
          <li>Le suivi, la préparation et l'expédition relèvent exclusivement du pilote vendeur.</li>
          <li>MerchHub ne peut garantir aucun délai de livraison, ni intervenir dans un retard ou un problème d'expédition.</li>
        </ul>
      </Section>

      <Section id="contact" icon="📩 Article 3" title="Contact — Support MerchHub">
        <p>
          Pour toute question concernant la plateforme, votre compte ou un problème général non lié à un produit, vous pouvez nous contacter par courriel :
        </p>
        <p className="text-[#FF3B00] uppercase tracking-widest font-display text-2xl break-all">
          <a href="mailto:merchhub8@gmail.com" className="hover:underline" data-testid="contact-email">merchhub8@gmail.com</a>
        </p>
        <p className="text-white/60">
          MerchHub ne traite aucune demande liée à un produit spécifique.
          Pour toute question concernant un article, l'acheteur doit communiquer directement avec le pilote vendeur.
        </p>
      </Section>

      <Section id="acceptation" icon="📄 Article 4" title="Acceptation des conditions">
        <p>En effectuant un achat sur MerchHub, l'acheteur confirme avoir lu et accepté :</p>
        <ul className="space-y-2 list-disc pl-5 marker:text-[#FF3B00]">
          <li>La politique de remboursement et d'échange</li>
          <li>La politique de livraison</li>
          <li>Les responsabilités respectives de MerchHub et des pilotes vendeurs</li>
        </ul>
      </Section>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap gap-4 justify-between items-center">
        <div className="text-xs uppercase tracking-widest text-white/40">© 2026 MerchHub — Tous droits réservés</div>
        <Link to="/catalogue" className="text-xs uppercase tracking-widest text-[#FF3B00] hover:underline">
          Retour au catalogue →
        </Link>
      </div>
    </div>
  );
}
